import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import withTranslateProvider from 'src/hoc/with-translate-provider'
import HeadMetaTags from '~/components/HeadMetaTags'
import TalentIntelligenceContainer from '~/features/talent-intelligence'
import en_all_features from '../../public/locales/en/all-features.json'
import jp_all_features from '../../public/locales/ja/all-features.json'
// import jsonLd from '../../public/schema.json'

const TalentIntelligencePage: FC = () => {
  const { t } = useTranslation()

  return (
    <>
      {/* <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      /> */}
      <HeadMetaTags
        title={t('meta:talent_intelligence:meta_title')}
        description={t('meta:talent_intelligence:meta_description')}
      />
      <TalentIntelligenceContainer />
    </>
  )
}

export default withTranslateProvider(TalentIntelligencePage, {
  en: { allFeature: en_all_features },
  ja: { allFeature: jp_all_features }
})
